module.exports = __webpack_public_path__ + "static/site-image-242f0bd1bb99891153d6d05d0233977d.png";